





















import Vue from 'vue';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import LeaverRuleForm from '@/components/leaversTool/LeaverRuleForm.vue';
import { LeaversToolConfigurationsService } from '@/services/LeaversTool/LeaversToolConfigurationsService';
import { LeaverRuleCreateUpdateModel, LeaversToolConfigurationModel, LeaverRuleModel, DocumentTypeModel } from '@/types';
import { ArrayUtils } from '@/utils';

export default Vue.extend({
  name: 'EditLeaverRule',
  props: {
    configurationId: {
      required: true
    },
    ruleId: {
      required: true
    }
  },
  data() {
    return {
      rule: {
        configurationId: this.configurationId
      } as LeaverRuleCreateUpdateModel,
      configuration: {} as LeaversToolConfigurationModel,
      isPageLoading: true
    };
  },
  async mounted(this: any) {
    const result = await LeaversToolConfigurationsService.getAsync(this.configurationId as number);
    this.configuration = result;
    this.configuration.configurableCurrentDocumentTypes = ArrayUtils.alphabeticalSort(this.configuration.configurableCurrentDocumentTypes as DocumentTypeModel[], (x) => x.description);
    this.configuration.configurableDestinationDocumentTypes = ArrayUtils.alphabeticalSort(this.configuration.configurableDestinationDocumentTypes as DocumentTypeModel[], (x) => x.description);

    const configRule = result.rules.find((x: LeaverRuleModel) => x.id === (this.ruleId as number)) as LeaverRuleModel;

    if (configRule) {
      this.rule.currentDocumentTypeId = configRule.currentDocumentType.id;
      this.rule.destinationDocumentTypeId = configRule.destinationDocumentType.id;
      this.rule.retentionPeriodType = configRule.retentionPeriodType;
      this.rule.retentionPeriod = configRule.retentionPeriod;
      this.rule.referenceId = configRule.reference ? configRule.reference.id : undefined;
      this.rule.referenceValue = configRule.referenceValue;
      this.rule.calculateFromReferenceId = configRule.calculateFromReference ? configRule.calculateFromReference.id : undefined;
    }

    this.isPageLoading = false;
  },
  components: {
    LoadingSpinner,
    LeaverRuleForm
  }
});
